import type { ReactNode } from 'react';

/** Landmark `main` para telas fora do layout autenticado (404, acesso negado, erro global). */
export function StandalonePage({ children }: { children: ReactNode }): ReactNode {
  return <main className="min-h-screen">{children}</main>;
}
